// extracted by mini-css-extract-plugin
export default {"title":"MasterSaleDetails_title__tmbsI","total":"MasterSaleDetails_total__pkLxH","edit":"MasterSaleDetails_edit__3rGH2","cancel":"MasterSaleDetails_cancel__XOj7v"};